// src/supabase.js
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

console.log("Supabase client loaded:", !!supabase);
console.log("Env URL:", import.meta.env.VITE_SUPABASE_URL ? "LOADED" : "MISSING");
console.log("Env Key:", import.meta.env.VITE_SUPABASE_ANON_KEY ? "LOADED" : "MISSING");
